"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkCustomerExistsReducer = exports.searchCustomerReducer = exports.createDefaultCustomerReducer = exports.fetchDefaultCustomerReducer = exports.updateCustomerReducer = exports.createCustomerReducer = exports.fetchCustomerReducer = exports.checkCustomerExistsSlice = exports.searchCustomerSlice = exports.createDefaultCustomerSlice = exports.fetchDefaultCustomerSlice = exports.updateCustomerSlice = exports.createCustomerSlice = exports.fetchCustomerSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const customerAction_1 = require("./customerAction");
const fetchInitialState = {
    loading: false,
    error: false,
    errorMessage: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: false,
    errorMessage: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: false,
    errorMessage: null,
    data: []
};
const fetchDefaultInitialState = {
    loading: false,
    error: false,
    errorMessage: null,
    data: []
};
const createDefaultInitialState = {
    loading: false,
    error: false,
    errorMessage: null,
    data: []
};
const searchInitialState = {
    loading: false,
    error: false,
    errorMessage: null,
    data: []
};
exports.fetchCustomerSlice = (0, toolkit_1.createSlice)({
    name: 'customer/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(customerAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.data = [];
            state.errorMessage = null;
        });
        builder.addCase(customerAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = false;
            state.data = action.payload;
            state.errorMessage = null;
        });
        builder.addCase(customerAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.data = [];
            state.errorMessage = action.error.message;
        });
    }
});
exports.createCustomerSlice = (0, toolkit_1.createSlice)({
    name: 'customer/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(customerAction_1.create.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.data = [];
            state.errorMessage = null;
        });
        builder.addCase(customerAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = false;
            state.data = action.payload;
            state.errorMessage = null;
        });
        builder.addCase(customerAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorMessage = action.error.message;
            state.data = [];
        });
    }
});
exports.updateCustomerSlice = (0, toolkit_1.createSlice)({
    name: 'customer/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(customerAction_1.update.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.errorMessage = null;
            state.data = [];
        });
        builder.addCase(customerAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = false;
            state.data = action.payload;
            state.errorMessage = null;
        });
        builder.addCase(customerAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.errorMessage = action.error.message;
            state.error = true;
            state.data = [];
        });
    }
});
exports.fetchDefaultCustomerSlice = (0, toolkit_1.createSlice)({
    name: 'customer/fetchDefaultCustomer',
    initialState: fetchDefaultInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(customerAction_1.fetchDefaultCustomer.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.errorMessage = null;
            state.data = [];
        });
        builder.addCase(customerAction_1.fetchDefaultCustomer.fulfilled, (state, action) => {
            state.loading = false;
            state.error = false;
            state.errorMessage = null;
            state.data = action.payload;
        });
        builder.addCase(customerAction_1.fetchDefaultCustomer.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorMessage = action.error.message;
            state.data = [];
        });
    }
});
exports.createDefaultCustomerSlice = (0, toolkit_1.createSlice)({
    name: 'customer/createDefaultCustomer',
    initialState: createDefaultInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(customerAction_1.createDefaultCustomer.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.errorMessage = null;
            state.data = [];
        });
        builder.addCase(customerAction_1.createDefaultCustomer.fulfilled, (state, action) => {
            state.loading = false;
            state.error = false;
            state.errorMessage = null;
            state.data = action.payload;
        });
        builder.addCase(customerAction_1.createDefaultCustomer.rejected, (state, action) => {
            state.loading = false;
            state.errorMessage = action.error.message;
            state.error = true;
            state.data = [];
        });
    }
});
exports.searchCustomerSlice = (0, toolkit_1.createSlice)({
    name: 'customer/search',
    initialState: searchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(customerAction_1.search.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.data = [];
        });
        builder.addCase(customerAction_1.search.fulfilled, (state, action) => {
            state.loading = false;
            state.error = false;
            state.errorMessage = null;
            state.data = action.payload;
        });
        builder.addCase(customerAction_1.search.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorMessage = action.error.message;
            state.data = [];
        });
    }
});
exports.checkCustomerExistsSlice = (0, toolkit_1.createSlice)({
    name: 'customer/checkCustomerExists',
    initialState: searchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(customerAction_1.checkCustomerExists.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.data = [];
        });
        builder.addCase(customerAction_1.checkCustomerExists.fulfilled, (state, action) => {
            state.loading = false;
            state.error = false;
            state.errorMessage = null;
            state.data = action.payload;
        });
        builder.addCase(customerAction_1.checkCustomerExists.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorMessage = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchCustomerReducer = exports.fetchCustomerSlice.reducer;
exports.createCustomerReducer = exports.createCustomerSlice.reducer;
exports.updateCustomerReducer = exports.updateCustomerSlice.reducer;
exports.fetchDefaultCustomerReducer = exports.fetchDefaultCustomerSlice.reducer;
exports.createDefaultCustomerReducer = exports.createDefaultCustomerSlice.reducer;
exports.searchCustomerReducer = exports.searchCustomerSlice.reducer;
exports.checkCustomerExistsReducer = exports.checkCustomerExistsSlice.reducer;
